import React from "react";
import {Redirect, Route, Switch, useLocation} from "react-router-dom";
import MainLayout from "./common/MainLayout";
import {useAuth} from "../context/authContext";
import {FLATTED_NAVIGATION_ITEMS, ROUTES} from "../utils/navigationItems";
import {getLandingPageURL} from "../utils/util";

const MainView = () => {
    const currentPath = useLocation().pathname;
    const auth = useAuth();
    const maybeActiveView = FLATTED_NAVIGATION_ITEMS.find(
        (e) => currentPath === e.to
    );
    const defaultFallbackPath = auth.hasAuthority("ALL_PATIENTS_QUICK_LIST_ACCESS")
        ? "/all_patients"
        : "/settings";
    const fallbackPath = currentPath === "/"
        ? getLandingPageURL(auth.getLandingPage?.())
        : defaultFallbackPath;

    return (
        <MainLayout
            data-test="appComponent"
            activeViewName={maybeActiveView ? maybeActiveView.title : ""}
        >
            <Switch>
                {Object.values(ROUTES).map(({ exact, canAccess, path, component }) => {
                    if ((!canAccess || canAccess(auth)) && component) {
                        return (
                            <Route
                                exact={exact}
                                key={path}
                                path={path}
                                render={(props) => component(props)}
                            />
                        );
                    }
                    return (
                        <Route
                            exact={exact}
                            key={path}
                            path={path}
                            render={() => <Redirect to={fallbackPath} />}
                        />
                    );
                })}
                <Route render={() => <Redirect to={fallbackPath} />} />

            </Switch>
        </MainLayout>
    );
};

export default MainView;
